import "./LocateMe.css";
import { vectorForGeolocation as vector } from "../../_config/layers/";
import React, { useRef, useState } from "react";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import { fromLonLat } from "ol/proj";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";

function LocateMe({ map }) {
  const { t } = useTranslation();
  const element = useRef();
  const [locationVisible, setLocationVisible] = useState(false);
  const [locationFeature, setLocationFeature] = useState(null);

  const handleClick = () => {
    if (locationVisible) {
      vector.getSource().removeFeature(locationFeature);
      setLocationVisible(false);
      setLocationFeature(null);
      return;
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, showError);
    } else {
      alert(t("locateMe.unsupported"));
    }
  };

  function showPosition(position) {
    const coords = [position.coords.longitude, position.coords.latitude];
    const olCoords = fromLonLat(coords, "EPSG:4326");

    vector.getSource().clear();

    const userLocation = new Feature({
      geometry: new Point(olCoords),
    });

    vector.getSource().addFeature(userLocation);

    map.getView().setCenter(olCoords);
    map.getView().setZoom(15);

    setLocationFeature(userLocation);
    setLocationVisible(true);
  }

  function showError(error) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        alert(t("locateMe.permissionDenied"));
        break;
      case error.POSITION_UNAVAILABLE:
        alert(t("locateMe.positionUnavailable"));
        break;
      case error.TIMEOUT:
        alert(t("locateMe.timeout"));
        break;
      default:
        alert(t("locateMe.unknownError"));
        break;
    }
  }

  return (
    <div id="LocateMe" className="LocateMe">
      <Button
        className="HorizontalButton"
        type="button"
        alt={t("locateMe.tooltip")}
        title={t("locateMe.tooltip")}
        onClick={handleClick}
        ref={element}
      >
        <i className="bi bi-crosshair iconLocaleMe"></i>
      </Button>
    </div>
  );
}

export default LocateMe;
